import { makeAutoObservable } from "mobx"
import { VoucherService } from "../services/api/voucherService"
import _ from 'lodash';
import { Cookies } from "react-cookie";
import { VoucherStatus, VoucherHistory, SendVoucherRequest, UseVoucherResponse } from "../models/voucher";
import { downloadFile } from "../services/api/utils";

export class VoucherStore {
    voucherService = new VoucherService();
    voucherHistory: VoucherHistory[] = [];
    voucherStatus: VoucherStatus = { bankId: '', id: '', purchased: -1, remained: -1, used: -1 };
    cookie: Cookies = new Cookies();
    useVoucherResult: UseVoucherResponse = {} as UseVoucherResponse;
    historyActionResult = {error: false};
    
    constructor() {
        makeAutoObservable(this);
    }

    load = async() => {
        await this.getVoucherStatus();
        await this.getVoucherHistory();
    }

    updateVoucherStatus = (status: VoucherStatus) => {
        this.voucherStatus = status;
    }

    updateVoucherHistory = (history: VoucherHistory[]) => {
        this.voucherHistory = _.orderBy(history, 'lastSendDate', 'desc');
    }

    sortVoucherHistory = (order: string, desc: boolean) => {
        this.voucherHistory = _.orderBy(this.voucherHistory, order, desc ? 'desc' : 'asc');
    }

    updateHistoryActionResult = (result: any) => {
        this.historyActionResult = result;
    }

    updateUseVoucherResult = (response: UseVoucherResponse) => {
        this.useVoucherResult = response;
    }

    getVoucherStatus = async () => {
        try {
            const bankId = this.cookie.get('_bId');
            const response = await this.voucherService.getVoucherStatus(bankId);
            this.updateVoucherStatus(response);
        } catch (e) {
            console.log(e);
        }
    }

    getVoucherHistory = async () => {
        try {
            const bankId = this.cookie.get('_bId');
            const response = await this.voucherService.getVoucherHistory(bankId);
            this.updateVoucherHistory(response);
        } catch (e) {
            console.log(e);
        }
    }
    
    sendVoucher = async (request: SendVoucherRequest) => {
        try {
            const bankId = this.cookie.get('_bId');
            request.bankId = bankId;
            const response = await this.voucherService.sendVoucher(request);
            this.updateUseVoucherResult(response);
            await this.getVoucherStatus();
            await this.getVoucherHistory();
        } catch (e) {
            console.log(e);
        }
    }
    
    resendVoucher = async (voucherId: string) => {
        try {
            const bankId = this.cookie.get('_bId');
            const response = await this.voucherService.resendVoucher({bankId: bankId, voucherId: voucherId});
            this.updateHistoryActionResult(response);
            await this.getVoucherHistory();
        } catch (e) {
            this.updateHistoryActionResult({error: true});
            console.log(e);
        }
    }

    cancelVoucher = async (voucherId: string) => {
        try {
            const bankId = this.cookie.get('_bId');
            const response = await this.voucherService.cancelVoucher({bankId: bankId, voucherId: voucherId});
            this.updateHistoryActionResult(response);
            await this.getVoucherStatus();
            await this.getVoucherHistory();
        } catch (e) {
            this.updateHistoryActionResult({error: true});
            console.log(e);
        }
    }

    exportHistory = async () => {
        try {
            const bankId = this.cookie.get('_bId');
            const response = await this.voucherService.exportHistory(bankId);
            downloadFile(response.blob, response.mimeType, response.fileName);
        } catch (e) {
            console.log(e);
        }
    }
}